export const localStorageItemNames = {
  TOKEN: "token",
  USER_EMAIL: "user_email",
  USER_ID: "user_id",
  ROLE: "role",
};

export const type = {
  USER: "USER",
  ADVISOR: "ADVISOR",
  ADMIN: "ADMIN",
};

export const messages = {
  SIGNIN_SUCCESS: "User Sign Up Successfully"
}

export const ratingTypes = {
  zeroToOne: "Fair",
  twoToThree: "Good",
  fourToFive: "Excellent"
}

export const status = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  VERIFIED: "VERIFIED"
}

export const currencies = {
  USD: '$',
  Euro: "€",
  HongKongDollar: "HK$",
  INR: '₹',
  Yen: "¥"
}